import React, {Component} from 'react';
import {Form, Icon, message, Modal} from "antd";
import UploadWall from "../../../../components/upload/UploadWall";
import ChunkUpload from "../../../../components/upload/ChunkUpload";
import BaseComponent from "../../../../base/BaseComponent";
import {Scrollbars} from "react-custom-scrollbars";
import PictureNormalFileItem from "../../../../components/upload/fileItem/PictureNormalFileItem";
import VideoNormalFileItem from "../../../../components/upload/fileItem/VideoNormalFileItem";
import {VIDEO_TYPE,PIC_TYPE} from "../../../../constants";
import AudioNormalFileItem from "../../../../components/upload/fileItem/AudioNormalFileItem";
import OtherNormalFileItem from "../../../../components/upload/fileItem/OtherNormalFileItem";
class UploadFileItem extends Component{
    render() {
        let {file} = this.props;
        let res = VIDEO_TYPE.find(item=>file?.originFileObj?.name.endsWith(item));
        let picRes = PIC_TYPE.find(item=>file?.originFileObj?.name.endsWith(item));
        if (PIC_TYPE.indexOf(file.suffix)>-1||picRes||PIC_TYPE.indexOf(file.ext)>-1) {
            return <PictureNormalFileItem {...this.props} showEdit={false} showSize={true}
                                          key={file.md5}
                                          showDelete={this.props.showDelete}
                                          showCheck={this.props.showCheck}
                                          onChange={this.props.onChange}/>;
        } else if (VIDEO_TYPE.indexOf(file.suffix)>-1 ||res||VIDEO_TYPE.indexOf(file.ext)>-1) {
            return <VideoNormalFileItem {...this.props} showEdit={false}
                                        showCheck={this.props.showCheck}
                                        key={file.md5}
                                        showDelete={this.props.showDelete}
                                        onChange={this.props.onChange}/>;
        }
    }
}
class UploadFile extends BaseComponent {
    static defaultProps = {
        showAddBtn: true,
        height: 280
    };
    constructor(props) {
        super(props);
        this.state = {
            fileList: [],
            maxSize: 1024 * 1024 * 1024 * 2  // 2GB

        }
    }

    componentDidMount() {
        this.setState({current: this.props.current});
        this.assemble(this.props.dataSource);
    }

    componentWillReceiveProps(nextProps, nextContext) {
            if (this.state.fileList !== nextProps.dataSource) {
                this.assemble(nextProps.dataSource);
            }
    }

    //组装数据  后端返回的以及自己上传的数据 按照这个格式组装
    assemble(data) {
        let fileList = [];
        let oldFileList = JSON.parse(JSON.stringify(this.state.fileList));
        if (!data.length) {
            this.setState({fileList: []});
            return
        }
        let newFileList = [];
        data && data.length && data.forEach((item, index) => {
            let status = false;
            let newPath = item.response && item.response.path ? item.response.path : item.icon;
            oldFileList && oldFileList.length && oldFileList.forEach((oldFileListItem, oldFileListIndex) => {
                let oldPath = oldFileListItem.path;
                if (newPath === oldPath && oldFileListItem.checked && item.name === oldFileListItem.name) {
                    status = true
                }
            });

            if (item.response && item.response.data) {
                item.response = {...item.response.data, ...item.response};
            }

            newFileList.push({
                uid:item.uid?item.uid:'',
                name: item.name,
                percent: isNaN(item.percent) ? 100 : item.percent,
                id: item.id,
                path: item.response && item.response.path ? item.response.path : item.icon,
                checked: status,
                thumbnailsPlayPath: item.response && item.response.thumbnailsPlayPath ? item.response.thumbnailsPlayPath : item.icon,
                originFileObj: {
                    name: item.name,
                    size: item.size,

                },
                suffix:item.suffix,
                extendedAttributeJson: {
                    mp4Path: item.extendedAttributeJson ? item.extendedAttributeJson.mp4Path : ''
                },
                response: {
                    name: item.name,
                    path: item.response && item.response.path ? item.response.path : item.icon,
                    size: item.size,
                    thumbnailsPlayPath: item.response && item.response.thumbnailsPlayPath ? item.response.thumbnailsPlayPath : item.icon
                }
            });
            this.setState({fileList: newFileList}, () => {

            })
        })

    }

    render() {
        let {fileList} = this.state;
        let that = this;
        return (
            <Scrollbars autoHeight autoHeightMax={400}>
                <UploadWall
                    multiple={true}
                    action="/storage/uploadFile"
                    fileList={fileList}
                    style={{padding: " 0", width: "615px"}}
                    customRequest={new ChunkUpload({
                        checkFileURL: "/storage/checkFile",
                        checkChunkURL: "/storage/checkChunk",
                        uploadChunkURL: "/storage/uploadChunk",
                        chunkUploadOverURL: "/storage/chunkIsUploadOver",
                        mergeChunksURL: "/storage/mergeChunk",
                    }).start}
                    icons={this.props.showAddBtn ? ["eye", "play", "download", "delete"] : []}
                    fileItemComponent={function (file,index) {
                        return that.fileItem
                    }}
                    showUploadBtn={false}
                    onRemove={this.handleRemoveFileList}
                    onDownload={this.onDownload}
                />
            </Scrollbars>

        )
    }

    fileItem = (props) => {
        return <UploadFileItem {...props} showDelete={this.props.showDelete} showCheck={this.props.showCheck}  onChange={(data,file) => {
           this.isCheckData(data, file)
        }}/>
    }

    isCheckData = (data, file) => {
        file.checked = data;
        this.setState({}, () => {
            this.props.callBack && this.props.callBack(this.state.fileList)
        })
    };
    handleRemoveFileList = file => {
            this.request({
                url: "/cm-sites-storage-management/interview/batchDelete?ids=" + file.id,
                method: "get",
                contentType: 'json',
                callBack: (data) => {
                    let fileList = this.state.fileList.filter(item => item.id !== file.id);
                    this.setState({
                        fileList
                    }, () => {
                        this.props.callBack && this.props.callBack(fileList)
                    });
                }
            });
        };
    onDownload = (file) => {
        if (file.path) {
            this.request({
                url: file.path + "?download=1",
                method: "downloadGet",
                contentType: "json",
            });
        } else {
            console.log("文件path丢失")
        }
    };
}

export default UploadFile;
